export var GlobalEvents;
(function (GlobalEvents) {
    GlobalEvents["CartAdd"] = "ploom:cart:add";
    GlobalEvents["CartIdLoaded"] = "ploom:cart:id:init";
    GlobalEvents["CartIsActive"] = "ploom:cart:active";
    GlobalEvents["InfoBannerStateChange"] = "ploom:infobanner:active:changed:success";
    GlobalEvents["ProductLimitReached"] = "ploom:product:limit:reached";
    GlobalEvents["StopVideo"] = "ploom:video:stop";
    GlobalEvents["UpdateLoyaltyPoints"] = "update:loyalty:points";
})(GlobalEvents || (GlobalEvents = {}));
const createCustomEvent = (eventName, additionalData) => {
    return new CustomEvent(eventName, {
        detail: {
            additionalData,
        },
    });
};
export function dispatchCustomEvent(eventName, additionalData) {
    if (typeof document === "undefined") {
        return Promise.resolve();
    }
    const event = createCustomEvent(eventName, additionalData);
    document.dispatchEvent(event);
    return new Promise((resolve) => setTimeout(resolve, 500));
}
//# sourceMappingURL=index.js.map